import { BlogSection } from '@/types/blog';

export const glaubenssaetzeSection: BlogSection = {
  id: 'geld-glaubenssaetze',
  title: 'Deine Geld-Glaubenssätze hinterfragen',
  content: `
    <h3 id="geld-glaubenssaetze">3. Deine Geld-Glaubenssätze hinterfragen</h3>
    
    <p>
      Viele finanzielle Entscheidungen beruhen auf unbewussten Überzeugungen wie „Geld ist schlecht" oder 
      „Ich bin nicht gut mit Geld". Diese Denkmuster können durch gezielte Reflexion verändert werden.
    </p>
    
    <div class="my-6">
      <img 
        src="/images/blog/sparschwein.jpg" 
        alt="Ein Sparschwein und Münzen symbolisieren frühe Erfahrungen mit Taschengeld und das Erlernen von Finanzwissen in der Kindheit" 
        class="rounded-lg w-full h-auto shadow-md" 
        width="800"
        height="533"
      />
      <p class="text-sm text-center mt-2 text-joerg-600">Unsere Glaubenssätze zu Geld werden oft in der Kindheit durch frühe Erfahrungen mit Taschengeld und familiäre Gespräche über Finanzen geprägt</p>
    </div>
    
    <p>Stelle dir Fragen wie:</p>
    
    <ul class="list-disc pl-5 my-4">
      <li>Woher stammt mein Glaubenssatz über Geld?</li>
      <li>Ist er wirklich wahr?</li>
      <li>Wie würde ich anders handeln, wenn ich eine neue Perspektive einnehmen würde?</li>
    </ul>
    
    <div class="my-6 bg-joerg-50 p-5 rounded-lg border border-joerg-100">
      <h4 class="text-joerg-800 font-medium mb-3">Übung: Glaubenssätze transformieren</h4>
      <table class="w-full text-left">
        <thead>
          <tr>
            <th class="py-2">Limitierender Glaubenssatz</th>
            <th class="py-2">Ermächtigender Glaubenssatz</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="py-2 pr-4 border-b border-joerg-100">"Über Geld spricht man nicht"</td>
            <td class="py-2 border-b border-joerg-100">"Offene Gespräche über Geld helfen mir, bessere Entscheidungen zu treffen"</td>
          </tr>
          <tr>
            <td class="py-2 pr-4 border-b border-joerg-100">"Für Geld muss man hart arbeiten"</td>
            <td class="py-2 border-b border-joerg-100">"Geld folgt dem Wert, den ich schaffe, nicht nur meiner Anstrengung"</td>
          </tr>
          <tr>
            <td class="py-2 pr-4">"Ich verstehe nichts von Finanzen"</td>
            <td class="py-2">"Ich kann Schritt für Schritt finanzielle Kompetenz aufbauen"</td>
          </tr>
        </tbody>
      </table>
    </div>
  `
};
